module.exports = __webpack_public_path__ + "static/Eye-c6aa51b22fd1e245a056e86678e6f1a8.gif";